import CacheStore from './CacheStore.js';

/**
 * Cache store manager.
 */
export default class GlobalCacheStore extends CacheStore {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private global: any;

	/**
	 * Constructor.
	 *
	 * @param [global] Global/Window object.
	 */
	constructor(global?: Window) {
		super();
		this.global = global || window;
	}

	/**
	 * Returns store.
	 *
	 * @param name Name.
	 * @returns Map.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public override getStore(name: string): Map<any, any> {
		this.global.$ikeaKompisCacheStores = this.global.$ikeaKompisCacheStores || {};
		this.global.$ikeaKompisCacheStores[name] =
			this.global.$ikeaKompisCacheStores[name] || new Map();
		return this.global.$ikeaKompisCacheStores[name];
	}
}
